import { fork } from 'redux-saga/effects';
import { appSagas } from "./appSagas.js";
import { authSagas } from "../modules/Auth/authSagas.js";
import { transactionsSagas } from "../modules/Transactions/transactionsSagas";

export function* coreSagas() {
    yield fork(appSagas);
    yield fork(authSagas);
    yield fork(transactionsSagas);
}
